import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { ButtonStyles } from '@stories/Elements/Forms/Buttons/Button.styles';
import styled from 'styled-components';

const Container = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  backdrop-filter: blur(3px);
`;

const Modal = styled.div`
  background: ${brand.white};
  padding: ${fluid(20, 30)} ${fluid(20, 24)};
  text-align: center;
  max-width: 725px;
  font-size: 16px;
  max-height: 80vh;
  overflow-y: auto;
  margin-bottom: 15vw;
  position: relative;

  @media ${until(Device.MobileLarge)} {
    margin-bottom: 0px;
    justify-content: center;
  }
`;

const ModalInner = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  margin-bottom: 12px;
  line-height: 1.4;
  font-size: 20px;
  ${fonts.helvetica['93-black-extended']};

  @media ${until(Device.Tablet)} {
    padding-right: 15px;
  }
`;

const Description = styled.p`
  line-height: 1.5;
  font-size: 16px;
  ${fonts.helvetica['55-roman']};

  a {
    color: ${brand.black};
    text-decoration: underline;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  margin-top: 20px;
  flex-wrap: wrap;

  @media ${from(Device.Tablet)} {
    [data-buttons='3'] & {
      flex-wrap: nowrap;

      ${ButtonStyles.ButtonElement}:first-child {
        margin-right: 50px;
      }
    }
  }

  @media ${until(Device.Tablet)} {
    ${ButtonStyles.ButtonElement} {
      width: 100%;
    }
  }
`;

const Close = styled.button.attrs({ type: 'button' })`
  ${ButtonReset};
  position: absolute;
  top: 20px;
  right: 20px;
  transform: translate(50%, -50%);
  width: 16px;
  height: 16px;

  @media ${from(Device.Tablet)} {
    width: 20px;
    height: 20px;
  }
`;

const CookiePopupStyles = {
  Container,
  Modal,
  ModalInner,
  Title,
  Description,
  Buttons,
  Close,
};

export default CookiePopupStyles;
